<template>

  <div class="grid-view charge-search-tab">
    <div class="main-content" style="overflow-y: auto;">
      <div class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="185014"
          :grid-options="gridOptions"
          :export-file-name="$t(filename)"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :show-row-groups="dataListDragGroup"
          @saveColumnState="saveColumnState"
        />
      </div>
      <div id="footer-wrapper" class="pagination-wrapper amount-sum" style="flex-wrap: unset;align-items: unset;padding: 2px 5px;line-height: 28px;">
        <div style="display: flex;flex-direction: row-reverse;min-width: 600px">
          <job-amount-sum-by-currency
            key="amountSumByCurrency"
            :data-provider="dataProvider"
            cache-prefix="AccountTab"
            @callback="onSumCallbak"
          />
          <amount-sum-master-bold
            key="sumJobEquivalentRMB"
            ref="sumJobEquivalentRMB"
            datafield="EQUIVALENT_RMB"
            :title="$t('CargoMsg.Cargo_ConversionProfitCNYP')"
            :data-provider="rowData"
          />
          <amount-sum-master-bold
            key="sumJobRmbEquivalentPayable"
            ref="sumJobRmbEquivalentPayable"
            datafield="OTHER_PAY_AMOUNT"
            :title="$t('CargoMsg.Cargo_ConversionAPCNY') + ':'"
            :data-provider="rowData"
          />
          <amount-sum-master-bold
            key="sumJobRmbEquivalentReceiveable"
            ref="sumJobRmbEquivalentReceiveable"
            datafield="OTHER_RECEIVE_AMOUNT"
            :title="$t('CargoMsg.Cargo_ConversionARCNY') + ':'"
            :data-provider="rowData"
          />
        </div>
        <!-- <amount-sum-master
          key="sumAccountUnpaid"
          ref="sumAccountUnpaid"
          datafield="PAY_UN_"
          :data-provider="rowData"
          :has-muti-currency="true"
          :is-sum-visible="false"
          :title="$t('CargoMsg.Cargo_UnpaidP')"
        />
        <amount-sum-master
          key="sumAccountNotReceived"
          ref="sumAccountNotReceived"
          datafield="RECEIVE_UN_"
          :has-muti-currency="true"
          :is-sum-visible="false"
          :data-provider="rowData"
          :title="$t('CargoMsg.Cargo_NotCollectedP')"
        />
        <amount-sum-master
          key="sumAccountPayable"
          ref="sumAccountPayable"
          datafield="PAY_"
          :has-muti-currency="true"
          :is-sum-visible="false"
          :data-provider="rowData"
          :title="$t('CargoMsg.Cargo_DuesP')"
        />
        <amount-sum-master
          key="sumAccountReceivable"
          ref="sumAccountReceivable"
          datafield="RECEIVE_"
          :has-muti-currency="true"
          :data-provider="rowData"
          :title="$t('CargoMsg.Cargo_ReceivableP')"
        /> -->
        <div style="flex-grow: 1;display: inline-flex;flex-wrap: wrap;">
          <template v-if="!showSumPop">
            <div style="display: inline-flex;flex-wrap: wrap;">
              <span>{{ $t('FinanceManage.CurrencyAccountsReceivable') }}</span>
              <div v-for="(item,index) in arCurrencySum" :key="index">
                <span style="padding-right: 8px;">{{ item.currency }}</span>
                <span style="padding-right: 8px;color:gray;">{{ item.amount.toFixed(2) }}</span>
              </div>
            </div>
            <div style="display: inline-flex;flex-wrap: wrap;">
              <span>{{ $t('FinanceManage.CurrencyAccountsPayable') }}</span>
              <div v-for="(item,index) in apCurrencySum" :key="index">
                <span style="padding-right: 8px;">{{ item.currency }}</span>
                <span style="padding-right: 8px;color:gray;">{{ item.amount.toFixed(2) }}</span>
              </div>
            </div>
          </template>
        </div>
        <div style="display: inline-flex;min-width: 150px">
          <div>{{ $t('CargoMsg.Cargo_AllAmountP')+rowData.length }}</div>
          <div style="margin: 0px 10px;">{{ $t('CargoMsg.Cargo_SelectedItems',['['+numSelected+']']) }}</div>
        </div>
      </div>
      <cargo-template-selector-dialog
        :visible.sync="templateSelectorDialog.visible"
        :ctx="templateSelectorDialog.cxt"
        :category="templateSelectorDialog.category"
        :data="templateSelectorDialog.data"
        :pre-print-callback="prePrintFunc"
      />
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import AmountSumMasterBold from './AmountSumMasterBold'
import JobAmountSumByCurrency from './JobAmountSumByCurrency'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage } from '@/utils/commonUtil'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'

import { searchPrintCharge } from '@/api/clearing/charge'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import UIDUtil from '@/utils/uidUtil'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import { getCacheListByKey } from '@/utils/basicDataCache'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'AccountTab',
  components: { CargoAgGridWrapper, AmountSumMasterBold, JobAmountSumByCurrency, cargoTemplateSelectorDialog },
  props: {
    filename: { type: String, default: '' },
    data: { type: Array, required: true },
    rowDataChanged: {
      type: Function, default: () => {
      }
    },
    conversionCurrencySet: { type: Object, default: () => ({}) },
    perConfigName: { type: String, default: '' },
    gridRefreshId: { type: Number, default: 0 }
  },
  data() {
    return {
      loading: false,
      documentManage: new DocumentManage(),
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: 'CHARGE_LIST',
        data: {}
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDataChanged: this.rowDataChanged
      },
      columnDefs: [],
      currencyColumnDefs: [],
      specialExpenseColumnDefs: [],
      rowData: [],
      dataProvider: [],
      numSelected: 0,
      showSumPop: false, // 是否显示合计弹窗
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      isSpecialExpenseEntryFunction: false, // 专项费用录入功能配置
      arCurrencySum: [],
      apCurrencySum: [],
      currencyRateMap: new Map() // 币种汇率映射
    }
  },
  computed: {
    finalColumnDefs() {
      if (this.isSpecialExpenseEntryFunction) {
        return [...this.columnDefs, ...this.currencyColumnDefs, ...this.specialExpenseColumnDefs]
      } else {
        return [...this.columnDefs, ...this.currencyColumnDefs]
      }
    }
  },
  watch: {
    data(newVal) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'ACCOUNT_ID')
      this.rowData = newVal
      this.toStatisticsCurrency()
      this.dataProvider = this.rowData
      selectedStatus.revert()
    },
    conversionCurrencySet() {
      this.toStatisticsCurrency()
    }
  },
  created() {
    this.rowData = this.data
    this.toStatisticsCurrency()
    this.dataProvider = this.rowData
    this.initConfig()
  },
  beforeMount() {
    this.gridOptions.onSelectionChanged = (event) => {
      this.onCheckBoxClick(event)
    }
    const context = this
    this.documentManage.set('onClickAccountColumn', function(accountId, jobNo) {
      context.queryJobChangeDetail(accountId, jobNo)
    })
    this.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'ACCOUNT_ID', width: 180, enableRowGroup: true,
        excelRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId')
        },
        valueFormatter: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId')
        },
        onCellClicked: (params) => {
          context.queryJobChangeDetail(params.value, params.data.JOB_NO)
        },
        comparator: this.settleAccountComparator
      },
      // <!--        Add by Deep Lau 2016-04-14      -->
      { headerName: this.$t('CargoMsg.Cargo_PaymentAgainstMonthlySoa'), field: 'INVOICE_MODE', width: 180,
        cellRenderer: params => {
          return ColumnUtils.cleaningModeLable(Number(params.value))
        } },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableUSD'), field: 'RECEIVE_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesUSD'), field: 'PAY_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableCNY'), field: 'RECEIVE_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedCNY'), field: 'RECEIVED_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesCNY'), field: 'PAY_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidCNY'), field: 'PAY_PAID_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableEUR'), field: 'RECEIVE_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesEUR'), field: 'PAY_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableHKD'), field: 'RECEIVE_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesHKD'), field: 'PAY_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableNGN'), field: 'RECEIVE_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedNGN'), field: 'RECEIVED_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidNGN'), field: 'PAY_PAID_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesNGN'), field: 'PAY_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableGBP'), field: 'RECEIVE_GBP', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesGBP'), field: 'PAY_GBP', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableJPY'), field: 'RECEIVE_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesJPY'), field: 'PAY_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedJPY'), field: 'RECEIVED_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidJPY'), field: 'PAY_PAID_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionARCNY'), field: 'RECEIVE_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionReceivedCNY'), field: 'RECEIVED_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPCNY'), field: 'PAY_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionPayPaidCNY'), field: 'PAY_PAID_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAREUR'), field: 'RECEIVE_OTHER_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPEUR'), field: 'PAY_OTHER_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionReceivedEUR'), field: 'RECEIVED_OTHER_EUR', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionPayPaidEUR'), field: 'PAY_PAID_OTHER_EUR', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionARHKD'), field: 'RECEIVE_OTHER_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPHKD'), field: 'PAY_OTHER_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionReceivedHKD'), field: 'RECEIVED_OTHER_HKD', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionPayPaidHKD'), field: 'PAY_PAID_OTHER_HKD', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionARGBP'), field: 'RECEIVE_OTHER_GBP', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPGBP'), field: 'PAY_OTHER_GBP', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionARJPY'), field: 'RECEIVE_OTHER_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPJPY'), field: 'PAY_OTHER_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionARNGN'), field: 'RECEIVE_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPNGN'), field: 'PAY_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionReceivedNGN'), field: 'RECEIVED_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionPayPaidNGN'), field: 'PAY_PAID_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ConversionReceivedCNY'), field: 'RECEIVED_EQUIVALENT_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum'
      },
      { headerName: this.$t('CargoMsg.Cargo_ConversionPaidCNY'), field: 'PAY_PAID_EQUIVALENT_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedUSD'), field: 'RECEIVE_UN_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedUSD'), field: 'RECEIVED_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidUSD'), field: 'PAY_PAID_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidUSD'), field: 'PAY_UN_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedCNY'), field: 'RECEIVE_UN_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidCNY'), field: 'PAY_UN_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedEUR'), field: 'RECEIVE_UN_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedEUR'), field: 'RECEIVED_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidEUR'), field: 'PAY_PAID_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidEUR'), field: 'PAY_UN_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedHKD'), field: 'RECEIVE_UN_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedHKD'), field: 'RECEIVED_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidHKD'), field: 'PAY_PAID_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidHKD'), field: 'PAY_UN_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedGBP'), field: 'RECEIVE_UN_GBP', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidGBP'), field: 'PAY_UN_GBP', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedJPY'), field: 'RECEIVE_UN_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidJPY'), field: 'PAY_UN_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedNGN'), field: 'RECEIVE_UN_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidNGN'), field: 'PAY_UN_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionARCNY'), field: 'RECEIVE_UN_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPCNY'), field: 'PAY_UN_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAREUR'), field: 'RECEIVE_UN_OTHER_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPEUR'), field: 'PAY_UN_OTHER_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionARHKD'), field: 'RECEIVE_UN_OTHER_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPHKD'), field: 'PAY_UN_OTHER_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionARGBP'), field: 'RECEIVE_UN_OTHER_GBP', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPGBP'), field: 'PAY_UN_OTHER_GBP', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('SeaExport.DateOfDelivery'), field: 'DELIVER_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },
      { headerName: this.$t('SeaExport.DateOfArrivalTheWarehouse'), field: 'ARRIVE_STORAGE_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionARJPY'), field: 'RECEIVE_UN_OTHER_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPJPY'), field: 'PAY_UN_OTHER_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionARNGN'), field: 'RECEIVE_UN_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPNGN'), field: 'PAY_UN_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2)
        },
        summaryMode: 'sum'
      },
      { headerName: this.$t('CargoMsg.Cargo_Documents'), field: 'DC_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      }
    ]
    this.specialExpenseColumnDefs = [{
      headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableTotal'),
      colId: 'specialChargeApSum',
      field: 'specialChargeApSum',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }, {
      headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableCurrency'),
      colId: 'specialChargeApCurrency',
      field: 'specialChargeApCurrency',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }, {
      headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableTotal'),
      colId: 'specialChargeArSum',
      field: 'specialChargeArSum',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }, {
      headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableCurrency'),
      colId: 'specialChargeArCurrency',
      field: 'specialChargeArCurrency',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }]
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    print(conditions) {
      const selections = this.gridOptions.api.getSelectedRows()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSettlingParty'))
      } else {
        const accountIds = selections.map(item => item.ACCOUNT_ID)
        const requestBody = { queryConditions: { ...conditions, accountIds: accountIds.join(',') }}
        searchPrintCharge(requestBody).then(res => {
          const chargeList = res.data
          this.getPrintHandler(chargeList)
        }).catch(err => {
          // todo-shengsheng  Desc:
          console.log(err)
        })
      }
    },
    getPrintHandler(chargeList) {
      if (chargeList && chargeList.length > 0) {
        const data = {}
        data.CHARGE_UUID = chargeList
        data.printSource = DocumentConstants.BATCH_PRINT_CWZH.code
        data.showPreview = false
        this.templateSelectorDialog.data = data
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoEligibleExpenseToPrint'))
      }
    },
    async prePrintFunc(event) {
      const groupCode = UIDUtil.createUID()
      const chargeKeys = []
      const jobKeys = []
      for (const charge of event.parameter.CHARGE_UUID) {
        if (!chargeKeys.includes(charge.chargeId)) {
          chargeKeys.push(charge.chargeId)
          if (!jobKeys.includes(charge.jobId)) {
            jobKeys.push(charge.jobId)
          }
        }
      }

      await StimulSoftUtil.stiReportPreview(event.template, { uuid: groupCode }, {
        'GroupCode': groupCode,
        'CHARGE_UUID': chargeKeys,
        'JOB_UUID': jobKeys,
        'printSource': DocumentConstants.BATCH_PRINT_CWZH.code
      }, 1, event.exportType)
    },
    onCheckBoxClick(event) {
      const selections = getGridSelected(this.gridOptions)
      this.numSelected = selections.length
      if (selections.length > 0) {
        this.loading = getLoading()
        // this.$refs.sumAccountReceivable.setDataProvider(selections, event)
        // this.$refs.sumAccountPayable.setDataProvider(selections, event)
        // this.$refs.sumAccountNotReceived.setDataProvider(selections, event)
        // this.$refs.sumAccountUnpaid.setDataProvider(selections, event)
        // this.$refs.sumAccountAr.setDataProvider(selections, event)
        // this.$refs.sumAccountAp.setDataProvider(selections, event)
        this.$refs.sumJobEquivalentRMB.setDataProvider(selections)
        this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(selections)
        this.$refs.sumJobRmbEquivalentPayable.setDataProvider(selections)
        this.dataProvider = selections
        this.loading.close()
      } else {
        this.$nextTick(() => {
          this.loading = getLoading()
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.data && node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              // this.$refs.sumAccountReceivable.setDataProvider(this.rowData, event)
              // this.$refs.sumAccountPayable.setDataProvider(this.rowData, event)
              // this.$refs.sumAccountNotReceived.setDataProvider(this.rowData, event)
              // this.$refs.sumAccountUnpaid.setDataProvider(this.rowData, event)
              // this.$refs.sumAccountAr.setDataProvider(this.rowData, event)
              // this.$refs.sumAccountAp.setDataProvider(this.rowData, event)
              this.$refs.sumJobEquivalentRMB.setDataProvider(this.rowData)
              this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(this.rowData)
              this.$refs.sumJobRmbEquivalentPayable.setDataProvider(this.rowData)
              this.dataProvider = this.rowData
            }
            if (hasDisplay.length < this.rowData.length) {
              // this.$refs.sumAccountReceivable.setDataProvider(hasDisplay, event)
              // this.$refs.sumAccountPayable.setDataProvider(hasDisplay, event)
              // this.$refs.sumAccountNotReceived.setDataProvider(hasDisplay, event)
              // this.$refs.sumAccountUnpaid.setDataProvider(hasDisplay, event)
              // this.$refs.sumAccountAr.setDataProvider(hasDisplay, event)
              // this.$refs.sumAccountAp.setDataProvider(hasDisplay, event)
              this.$refs.sumJobEquivalentRMB.setDataProvider(hasDisplay)
              this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(hasDisplay)
              this.$refs.sumJobRmbEquivalentPayable.setDataProvider(hasDisplay)
              this.dataProvider = selections
            }
          } else {
            // this.$refs.sumAccountReceivable.setDataProvider(hasDisplay, event)
            // this.$refs.sumAccountPayable.setDataProvider(hasDisplay, event)
            // this.$refs.sumAccountNotReceived.setDataProvider(hasDisplay, event)
            // this.$refs.sumAccountUnpaid.setDataProvider(hasDisplay, event)
            // this.$refs.sumAccountAr.setDataProvider(hasDisplay, event)
            // this.$refs.sumAccountAp.setDataProvider(hasDisplay, event)
            this.$refs.sumJobEquivalentRMB.setDataProvider(hasDisplay)
            this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(hasDisplay)
            this.$refs.sumJobRmbEquivalentPayable.setDataProvider(hasDisplay)
            this.dataProvider = selections
          }
          this.loading.close()
        })
      }
    },
    saveColumnState() {
      this.$emit('saveColumnState')
    },
    queryJobChangeDetail(accountId, jobNo) {
      // 点击 客户单位列 触发
      // console.log('query jo', accountId)
      this.$emit('clickAccountId', { accountId, jobNo })
    },
    settleAccountComparator(account1, account2, node1, node2) {
      const a1 = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', account1, 'chineseName')
      const a2 = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', account2, 'chineseName')

      return ('' + a1).localeCompare(a2, 'zh-Hans-CN', { sensitivity: 'accent' })
    },
    onSumCallbak(data) {
      this.showSumPop = data.showPop
      this.arCurrencySum = data.arCurrencySum
      this.apCurrencySum = data.apCurrencySum
    },
    toStatisticsCurrency(rowData) {
      if (!rowData) {
        rowData = this.rowData
      }
      const currencyColumnDefs1 = this.toStatisticsOriginCurrency(rowData)
      const currencyColumnDefs2 = this.toStatisticsConversionCurrency(rowData)
      this.currencyColumnDefs = [...currencyColumnDefs1, ...currencyColumnDefs2]
    },
    toStatisticsOriginCurrency() {
      const currencyColumnDefs = []
      const { currencies, originReceivable, originPayable, originNotCollected, originNotPaid, originReceived, originPaid } = this.conversionCurrencySet
      if (!(currencies && currencies.length > 0 && typeof originReceivable === 'boolean' && typeof originPayable === 'boolean' &&
        typeof originNotCollected === 'boolean' && typeof originNotPaid === 'boolean' && typeof originReceived === 'boolean' &&
        typeof originPaid === 'boolean' && (originReceivable || originPayable || originNotCollected || originNotPaid || originReceived || originPaid))) {
        return currencyColumnDefs
      }
      for (const currency of currencies) {
        if (currency === 'CNY') {
          continue
        }
        if (currency === 'RMB') {
          if (originReceivable) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyReceivable', [currency]),
              field: 'RECEIVE_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['RECEIVE_RMB'], 2, true)
              }
            })
          }
          if (originPayable) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyPayable', [currency]),
              field: 'PAY_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['PAY_RMB'], 2, true)
              }
            })
          }
          if (originNotCollected) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyNotReceived', [currency]),
              field: 'RECEIVE_UN_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['RECEIVE_UN_RMB'], 2, true)
              }
            })
          }
          if (originNotPaid) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyUnpaid', [currency]),
              field: 'PAY_UN_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['PAY_UN_RMB'], 2, true)
              }
            })
          }
          if (originReceived) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyReceived', [currency]),
              field: 'RECEIVED_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['RECEIVED_RMB'], 2, true)
              }
            })
          }
          if (originPaid) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyPaid', [currency]),
              field: 'PAY_PAID_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['PAY_PAID_RMB'], 2, true)
              }
            })
          }
        } else {
          if (originReceivable) {
            const field = 'RECEIVE_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyReceivable', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originPayable) {
            const field = 'PAY_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyPayable', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originNotCollected) {
            const field = 'RECEIVE_UN_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyNotReceived', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originNotPaid) {
            const field = 'PAY_UN_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyUnpaid', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originReceived) {
            const field = 'RECEIVED_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyReceived', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originPaid) {
            const field = 'PAY_PAID_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyPaid', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
        }
      }
      return currencyColumnDefs
    },
    isExistField(field) {
      return this.columnDefs.findIndex(p => p.field === field) > -1
    },
    toStatisticsConversionCurrency(rowData) {
      const currencyColumnDefs = []
      const { currencies, receivable, payable, notCollected, notPaid, received, paid } = this.conversionCurrencySet
      if (!(currencies && currencies.length > 0 && typeof receivable === 'boolean' && typeof payable === 'boolean' &&
        typeof notCollected === 'boolean' && typeof notPaid === 'boolean' && typeof received === 'boolean' && typeof paid === 'boolean' && (receivable || payable || notCollected || notPaid || received || paid))) {
        return currencyColumnDefs
      }
      const allCurrencyInfo = getCacheListByKey(TYPE_NAMES.basic_data_Currency)
      for (const currency of currencies) {
        const receiveEquivalentField = 'RECEIVE_EQUIVALENT_' + currency
        const payEquivalentField = 'PAY_EQUIVALENT_' + currency
        const receiveUnEquivalentField = 'RECEIVE_UN_EQUIVALENT_' + currency
        const payUnEquivalentField = 'PAY_UN_EQUIVALENT_' + currency
        const receivedEquivalentField = 'RECEIVED_EQUIVALENT_' + currency
        const payPaidField = 'PAY_PAID_EQUIVALENT_' + currency
        if (receivable) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_ConversionARCurrency', [currency]),
            field: receiveEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (payable) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_ConversionAPCurrency', [currency]),
            field: payEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (notCollected) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_ConversionOutstandingARCurrency', [currency]),
            field: receiveUnEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (notPaid) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_OutstandingConversionAPInCurrency', [currency]),
            field: payUnEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (received) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_ConversionOutstandingReceivedCurrency', [currency]),
            field: receivedEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (paid) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_OutstandingConversionPaidInCurrency', [currency]),
            field: payPaidField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        for (const row of rowData) {
          if (row.hasOwnProperty(receiveEquivalentField) && row.hasOwnProperty(payEquivalentField) && row.hasOwnProperty(receiveUnEquivalentField) && row.hasOwnProperty(payUnEquivalentField) && row.hasOwnProperty(receivedEquivalentField) && row.hasOwnProperty(payPaidField)) {
            break
          }
          let receiveEquivalentSum = 0
          let payEquivalentSum = 0
          let receiveUnEquivalentSum = 0
          let payUnEquivalentSum = 0
          let receivedEquivalentSum = 0
          let payPaidSum = 0
          for (const { code } of allCurrencyInfo) {
            let rate = this.getRate(currency, code)
            if (rate === Infinity) {
              rate = 0
            }
            receiveEquivalentSum += (row['RECEIVE_' + code] || 0) * rate
            payEquivalentSum += (row['PAY_' + code] || 0) * rate
            receiveUnEquivalentSum += (row['RECEIVE_UN_' + code] || 0) * rate
            payUnEquivalentSum += (row['PAY_UN_' + code] || 0) * rate
            receivedEquivalentSum += (row['RECEIVED_' + code] || 0) * rate
            payPaidSum += (row['PAY_PAID_' + code] || 0) * rate
          }
          row[receiveEquivalentField] = receiveEquivalentSum
          row[payEquivalentField] = payEquivalentSum
          row[receiveUnEquivalentField] = receiveUnEquivalentSum
          row[payUnEquivalentField] = payUnEquivalentSum
          row[receivedEquivalentField] = receivedEquivalentSum
          row[payPaidField] = payPaidSum
        }
      }
      return currencyColumnDefs
    },
    getRate(sourceCurrency, targetCurrency) {
      if (sourceCurrency === targetCurrency) {
        return 1
      }
      const key = `${sourceCurrency}-${targetCurrency}`
      if (this.currencyRateMap.has(key)) {
        return this.currencyRateMap.get(key)
      } else {
        const rate = RateUtil.getForeignExchangeRateSafely(sourceCurrency, targetCurrency, new Date(), 0, 0)
        this.currencyRateMap.set(key, rate)
        return rate
      }
    },
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
    }
  }
}
</script>

<style scoped lang="scss">
  .account-tab /deep/ .account-column{
    text-align: center;
    &:hover{
      color:blue;font-weight: bold;font-size: 12px;border-bottom: 1px solid blue
    }
  }

</style>
